/* EasyClean theme JS — all components are data-attribute driven */
(function(){
"use strict";

/* ---------- reveal on scroll ---------- */
var io = new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
setTimeout(function(){ document.querySelectorAll('.reveal:not(.in)').forEach(function(el){ el.classList.add('in'); }); },3000);

/* ---------- mobile drawer ---------- */
window.toggleDrawer = function(open){
  var d=document.getElementById('drawer'); if(d) d.classList.toggle('open', open);
  document.body.style.overflow = open ? 'hidden' : '';
};

/* ---------- toast + cart ---------- */
var toastTimer;
function toast(msg){
  var t=document.querySelector('.toast');
  if(!t){ t=document.createElement('div'); t.className='toast'; document.body.appendChild(t); }
  t.textContent=msg; t.classList.add('show');
  clearTimeout(toastTimer); toastTimer=setTimeout(function(){ t.classList.remove('show'); },2600);
}
function refreshCartCount(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? '' : 'none';
    });
  }).catch(function(){});
}
function addToCart(variantId, name, qty){
  return fetch('/cart/add.js',{
    method:'POST', headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:variantId, quantity:qty||1}]})
  }).then(function(r){
    if(!r.ok) throw new Error('add failed');
    toast('✓ '+(name||'Produktet')+' er lagt i kurven');
    refreshCartCount();
  }).catch(function(){ toast('Hmm — prøv igen om et øjeblik'); });
}
document.addEventListener('click',function(e){
  var qa=e.target.closest('[data-quick-add]');
  if(qa){ e.preventDefault(); addToCart(qa.getAttribute('data-variant-id'), qa.getAttribute('data-product-title')); return; }
  var form=e.target.closest('form[data-ajax-atc]');
});

/* AJAX product form (data-ajax-atc) */
document.querySelectorAll('form[data-ajax-atc]').forEach(function(form){
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var id=form.querySelector('[name=id]').value;
    var q=parseInt((form.querySelector('[name=quantity]')||{}).value||'1',10);
    var btn=form.querySelector('[type=submit]'); if(btn){ btn.disabled=true; }
    addToCart(id, form.getAttribute('data-product-title'), q).finally(function(){ if(btn) btn.disabled=false; });
  });
});
/* Product page buybox: add to cart in the background so the cart drawer opens instead of redirecting to /cart */
document.querySelectorAll('form#product-form-buybox').forEach(function(form){
  form.addEventListener('submit',function(e){
    if(e.defaultPrevented) return;
    e.preventDefault();
    var btns=document.querySelectorAll('button[form="product-form-buybox"], #product-form-buybox [type=submit]');
    btns.forEach(function(b){ b.disabled=true; });
    fetch('/cart/add.js',{
      method:'POST', headers:{'Accept':'application/json'},
      body:new FormData(form)
    }).then(function(r){
      if(!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function(item){
      refreshCartCount();
      document.dispatchEvent(new CustomEvent('cart:added',{detail:item}));
      document.dispatchEvent(new CustomEvent('product:added',{detail:item}));
    }).catch(function(){
      form.submit();
    }).finally(function(){
      btns.forEach(function(b){ b.disabled=false; });
    });
  });
});
refreshCartCount();

/* ---------- hero phrase rotator ---------- */
document.querySelectorAll('[data-rotator]').forEach(function(wrap){
  var ps=wrap.querySelectorAll('.phrase'); if(ps.length<2) return;
  var i=0; setInterval(function(){ ps[i].classList.remove('on'); i=(i+1)%ps.length; ps[i].classList.add('on'); },2800);
});

/* ---------- quote carousel ---------- */
document.querySelectorAll('[data-quotes]').forEach(function(box){
  var quotes=box.querySelectorAll('q'); if(!quotes.length) return;
  var qi=0;
  function show(i){ qi=(i+quotes.length)%quotes.length;
    quotes.forEach(function(q,j){ q.classList.toggle('on', j===qi); });
    var c=box.parentElement.querySelector('[data-quote-count]'); if(c) c.textContent=(qi+1)+' / '+quotes.length;
  }
  box.parentElement.querySelectorAll('[data-quote-step]').forEach(function(b){
    b.addEventListener('click',function(){ show(qi+parseInt(b.getAttribute('data-quote-step'),10)); });
  });
  setInterval(function(){ show(qi+1); },6000);
  show(0);
});

/* ---------- quiz / chip-driven result cards ---------- */
document.querySelectorAll('[data-chip-group]').forEach(function(group){
  var target=document.getElementById(group.getAttribute('data-chip-group'));
  if(!target) return;
  group.addEventListener('click',function(e){
    var b=e.target.closest('button[data-name]'); if(!b) return;
    group.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
    b.classList.add('on');
    var map={name:'[data-f=name]',why:'[data-f=why]',price:'[data-f=price]',link:'[data-f=link]',tip:'[data-f=tip]'};
    Object.keys(map).forEach(function(k){
      var el=target.querySelector(map[k]); if(!el) return;
      var v=b.getAttribute('data-'+k); if(v==null) return;
      if(k==='link') el.href=v; else el.textContent=v;
    });
    var img=target.querySelector('img[data-f=img]');
    if(img){
      var u=b.getAttribute('data-img');
      if(u){ img.src=u; img.style.display='block'; }
      else { img.style.display='none'; }
    }
    target.classList.add('show');
    target.classList.add('flash'); setTimeout(function(){ target.classList.remove('flash'); },600);
  });
});

/* ---------- product gallery ---------- */
window.setImg=function(btn, i){
  var g=btn.closest('[data-gallery]'); if(!g) return;
  var strip=g.querySelector('[data-strip]');
  if(strip) Array.prototype.slice.call(strip.children).forEach(function(im, ix){ im.classList.toggle('on', ix===i); });
  g.querySelectorAll('.thumbs button').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');
};

/* mobile swipe gallery: build dots + track scroll, arrows, mouse drag */
document.querySelectorAll('[data-gallery]').forEach(function(g){
  var strip=g.querySelector('[data-strip]'), dots=g.querySelector('[data-dots]');
  if(!strip || !dots) return;
  dots.innerHTML='';
  var slides=Array.prototype.slice.call(strip.children);
  function cur(){ return Math.round(strip.scrollLeft/strip.clientWidth); }
  function go(i){ i=Math.max(0,Math.min(slides.length-1,i)); strip.scrollTo({left: strip.clientWidth*i, behavior:'smooth'}); }
  slides.forEach(function(s, i){
    if(s.tagName==='IMG') s.setAttribute('draggable','false');
    var d=document.createElement('span'); if(i===0) d.className='on';
    d.addEventListener('click',function(){ go(i); });
    dots.appendChild(d);
  });
  if(slides.length>1){
    ['prev','next'].forEach(function(dir){
      var b=document.createElement('button');
      b.type='button'; b.className='g-arrow g-'+dir;
      b.setAttribute('aria-label', dir==='prev' ? 'Forrige billede' : 'Næste billede');
      b.innerHTML=dir==='prev' ? '&#8249;' : '&#8250;';
      b.addEventListener('click',function(){ go(cur()+(dir==='prev'?-1:1)); });
      g.appendChild(b);
    });
  }
  strip.addEventListener('scroll',function(){
    var i=cur();
    dots.querySelectorAll('span').forEach(function(d, ix){ d.classList.toggle('on', ix===i); });
  },{passive:true});
  /* mouse drag (touch uses native swipe) */
  var down=false, startX=0, startL=0, moved=false;
  strip.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='mouse' || strip.scrollWidth<=strip.clientWidth+2) return;
    down=true; moved=false; startX=e.clientX; startL=strip.scrollLeft;
    strip.style.scrollSnapType='none'; strip.style.cursor='grabbing';
  });
  window.addEventListener('pointermove',function(e){
    if(!down) return;
    var dx=e.clientX-startX; if(Math.abs(dx)>4) moved=true;
    strip.scrollLeft=startL-dx;
  });
  window.addEventListener('pointerup',function(e){
    if(!down) return; down=false; strip.style.cursor='';
    var dx=e.clientX-startX, base=Math.round(startL/strip.clientWidth), i=base;
    if(dx<-40) i=base+1; else if(dx>40) i=base-1;
    go(i);
    setTimeout(function(){ strip.style.scrollSnapType=''; },450);
  });
  strip.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
});

/* ---------- hotspot scenes: tab switching ---------- */
document.querySelectorAll('[data-hot-tabs]').forEach(function(tabs){
  tabs.addEventListener('click',function(e){
    var b=e.target.closest('button[data-hot-target]'); if(!b) return;
    tabs.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
    b.classList.add('on');
    var sec=tabs.closest('.hotspots-sec'); if(!sec) return;
    sec.querySelectorAll('.hot-stage').forEach(function(s){
      s.classList.toggle('hot-hide', s.getAttribute('data-hot-stage')!==b.getAttribute('data-hot-target'));
    });
  });
});

/* ---------- hotspot image (tap to open) ---------- */
document.querySelectorAll('.hot-stage').forEach(function(stage){
  stage.addEventListener('click',function(e){
    var dot=e.target.closest('.hot-dot');
    stage.querySelectorAll('.hot-card').forEach(function(c){ c.classList.remove('open'); });
    if(dot){
      var card=dot.nextElementSibling;
      if(card && card.classList.contains('hot-card')) card.classList.add('open');
    }
  });
});
document.addEventListener('click',function(e){
  if(!e.target.closest('.hot-stage')){
    document.querySelectorAll('.hot-card.open').forEach(function(c){ c.classList.remove('open'); });
  }
});

/* ---------- sticky ATC ---------- */
var sticky=document.getElementById('sticky'), buybox=document.getElementById('buybox');
if(sticky && buybox){
  new IntersectionObserver(function(es){ sticky.classList.toggle('show', !es[0].isIntersecting); },{threshold:0}).observe(buybox);
}

/* ---------- stat counters ---------- */
var statIO=new IntersectionObserver(function(es){
  es.forEach(function(en){
    if(!en.isIntersecting) return; statIO.unobserve(en.target);
    var b=en.target, txt=b.textContent.trim();
    var m=txt.match(/^([\d.]+)(.*)$/); if(!m) return;
    var target=parseInt(m[1].replace(/\./g,''),10), suffix=m[2];
    var t0=performance.now(), dur=1400;
    (function tick(t){ var p=Math.min((t-t0)/dur,1), v=Math.round(target*(1-Math.pow(1-p,3)));
      b.textContent=v.toLocaleString('da-DK')+suffix;
      if(p<1) requestAnimationFrame(tick); })(t0);
  });
},{threshold:.5});
document.querySelectorAll('.stat b').forEach(function(b){ statIO.observe(b); });

/* ---------- before / after slider ---------- */
document.querySelectorAll('[data-ba]').forEach(function(wrap){
  var top=wrap.querySelector('.ba-top'), handle=wrap.querySelector('.ba-handle');
  if(!top||!handle) return;
  function setBA(clientX){
    var r=wrap.getBoundingClientRect();
    var x=(clientX-r.left)/r.width; x=Math.max(.06,Math.min(.94,x));
    top.style.width=(x*100)+'%'; handle.style.left=(x*100)+'%';
  }
  var dragging=false;
  wrap.addEventListener('pointerdown',function(e){ dragging=true; wrap.setPointerCapture(e.pointerId); setBA(e.clientX); });
  wrap.addEventListener('pointermove',function(e){ if(dragging) setBA(e.clientX); });
  wrap.addEventListener('pointerup',function(){ dragging=false; });
  wrap.addEventListener('pointercancel',function(){ dragging=false; });
  setTimeout(function(){
    top.style.transition='width .9s cubic-bezier(.33,0,0,1)'; handle.style.transition='left .9s cubic-bezier(.33,0,0,1)';
    top.style.width='38%'; handle.style.left='38%';
    setTimeout(function(){ top.style.width='62%'; handle.style.left='62%';
      setTimeout(function(){ top.style.width='50%'; handle.style.left='50%';
        setTimeout(function(){ top.style.transition=''; handle.style.transition=''; },900);
      },950);
    },950);
  },1200);
});
})();

/* ---------- predictive search ---------- */
var searchPop = document.getElementById('searchPop');
window.toggleSearch = function(open){
  if(!searchPop) return;
  searchPop.classList.toggle('open', open);
  if(open){ var i=document.getElementById('searchInput'); if(i) setTimeout(function(){ i.focus(); },200); }
};
document.addEventListener('keydown', function(e){ if(e.key==='Escape') toggleSearch(false); });
document.addEventListener('click', function(e){
  if(searchPop && searchPop.classList.contains('open') && !e.target.closest('.search-pop') && !e.target.closest('.search-link')) toggleSearch(false);
});
(function(){
  var input=document.getElementById('searchInput'), box=document.getElementById('searchResults');
  if(!input||!box) return;
  var timer;
  input.addEventListener('input', function(){
    clearTimeout(timer);
    var q=input.value.trim();
    if(q.length<2){ box.innerHTML=''; return; }
    timer=setTimeout(function(){
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
        .then(function(r){ return r.json(); })
        .then(function(data){
          var products=(data.resources&&data.resources.results&&data.resources.results.products)||[];
          if(!products.length){ box.innerHTML='<p class="sr-none">Ingen produkter matcher \u201c'+q+'\u201d \u2014 pr\u00f8v fx \u201cfuger\u201d, \u201cdamp\u201d eller \u201ccycle\u201d.</p>'; return; }
          box.innerHTML=products.map(function(p){
            var price=parseFloat(p.price).toLocaleString('da-DK',{minimumFractionDigits:0})+' kr';
            var img=p.featured_image&&p.featured_image.url?'<img src="'+p.featured_image.url+'" alt="">':'';
            return '<a class="sr-card" href="'+p.url+'">'+img+'<b>'+p.title+'</b><span>'+price+'</span></a>';
          }).join('')+'<div class="sr-all"><a href="/search?q='+encodeURIComponent(q)+'">Se alle resultater for \u201c'+q+'\u201d \u2192</a></div>';
        })
        .catch(function(){});
    }, 250);
  });
})();
